import { useState } from 'react'
import { validatePhoneNumber } from '../../services/apiService'
import { useTranslation } from '../../utils/translations'
import { FaSms, FaPhone } from 'react-icons/fa'
import LanguageToggle from '../Common/LanguageToggle'
import './PhoneLogin.css'

const PhoneLogin = ({ onSubmit, error, isLoading }) => {
  const [phone, setPhone] = useState('')
  const [selectedMethod, setSelectedMethod] = useState(null)
  const { t } = useTranslation()

  const handleSubmit = (method) => {
    if (validatePhoneNumber(phone) && method) {
      onSubmit(phone, method)
    }
  }

  const formatPhoneNumber = (value) => {
    // Remove all non-digits
    const cleaned = value.replace(/\D/g, '')
    
    // Don't format if empty
    if (!cleaned) return ''
    
    // Apply formatting based on length
    if (cleaned.length <= 3) {
      return cleaned
    } else if (cleaned.length <= 6) {
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`
    } else {
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`
    }
  }

  const handlePhoneChange = (e) => {
    const inputValue = e.target.value
    
    // Extract only digits
    const digits = inputValue.replace(/\D/g, '')
    
    // Limit to 10 digits max
    if (digits.length <= 10) {
      const formatted = formatPhoneNumber(digits)
      setPhone(formatted)
    }
  }

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-top-controls">
          <div></div>
          <LanguageToggle />
        </div>
        
        <div className="login-header">
          <img src="/logo.svg" alt="AoS Logo" className="login-logo" />
          <h1 className="login-title">{t('auth.signInTitle')}</h1>
          <p className="login-subtitle">{t('auth.signInSubtitle')}</p>
        </div>
        
        <form className="login-form">
          <div className="form-group">
            <label htmlFor="phone" className="form-label">{t('auth.phoneLabel')}</label>
            <input
              id="phone"
              type="tel"
              value={phone}
              onChange={handlePhoneChange}
              placeholder={t('auth.phonePlaceholder')}
              className="form-input"
              maxLength={14}
              required
            />
            {error && <p className="error-text">{error}</p>}
          </div>
          
          <div className="method-selection">
            <p className="method-selection-label">{t('auth.selectMethodSubtitle')}</p>
            <div className="method-buttons">
              <button 
                type="button"
                className="method-button"
                onClick={() => handleSubmit('sms')}
                disabled={!validatePhoneNumber(phone) || isLoading}
              >
                <FaSms className="method-button-icon" />
                <span>{t('auth.textMethod')}</span>
              </button>
              
              <button 
                type="button"
                className="method-button"
                onClick={() => handleSubmit('call')}
                disabled={!validatePhoneNumber(phone) || isLoading}
              >
                <FaPhone className="method-button-icon" />
                <span>{t('auth.callMethod')}</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export default PhoneLogin

